import React, { useContext } from "react";
import { AuthContext } from "../AuthContext";

export default function MenuToggle({ isOpen, onToggle, className = "" }) {
  const { user, initialized } = useContext(AuthContext);

  // Ne rien afficher pendant l'initialisation
  if (!initialized) {
    return <div className={`md:hidden ${className}`} />;
  }

  // Si l'utilisateur est connecté, afficher l'avatar avec dropdown
  if (user) {
    return (
      <button
        className={`md:hidden flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors ${className}`}
        onClick={onToggle}
        aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={isOpen}
      >
        {/* Icône d'avatar */}
        <div className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
        {/* Flèche dropdown */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
    );
  }

  // Sinon, afficher le menu hamburger classique
  return (
    <button
      className={`md:hidden p-2 ${className}`}
      onClick={onToggle}
      aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
      aria-expanded={isOpen}
    >
      <span className="text-2xl font-light">{isOpen ? "✕" : "☰"}</span>
    </button>
  );
}
